define('org/forgerock/openam/ui/common/util/uri/getCurrentFragmentParamString',["exports", "lodash", "org/forgerock/commons/ui/common/util/URIUtils"], function (exports, _lodash, _URIUtils) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _lodash2 = _interopRequireDefault(_lodash);

  var _URIUtils2 = _interopRequireDefault(_URIUtils);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * @returns {String} The current fragment query string or an empty string.
   */
  /*
   * Copyright 2016-2017 ForgeRock AS. All Rights Reserved
   *
   * Use of this code requires a commercial software license with ForgeRock AS.
   * or with one of its affiliates. All use shall be exclusively subject
   * to such license between the licensee and ForgeRock AS.
   */

  /**
   * @module org/forgerock/openam/ui/common/util/uri/getCurrentFragmentParamString
   */
  var getCurrentFragmentParamString = function getCurrentFragmentParamString() {
    var params = _URIUtils2.default.getCurrentFragmentQueryString();
    return _lodash2.default.isEmpty(params) ? "" : "&" + params;
  };

  exports.default = getCurrentFragmentParamString;
});

